/// <reference types="vite-plugin-svgr/client" />
import { Link as RouterLink } from 'react-router-dom';
// @mui
import type { BoxProps } from '@mui/material';

import SvgLogo from '../../assets/PflegenaviLogo.svg?react';

import type { JSX } from 'react';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export function Logo({ disabledLink = false, sx }: Props): JSX.Element {
  const logo = <SvgLogo height={30} width={145} />;

  if (disabledLink) {
    return logo;
  }

  return (
    <RouterLink to="/" style={{ height: 35 }}>
      {logo}
    </RouterLink>
  );
}
